<template>
    <div class="dashboard__leftpanel">
        <AddFunds/>
        <p class="title">All Investments</p>
        <div class="investment-card" v-for="(item, index) in portfolios" :key="index">
            <div class="white-box p-15" :class="isCreatedStatePortfolio(item.status)">
                <div class="underProcessIcon" v-if="item.status === 2" title="Payment under process">
                    <v-chip
                        small
                        color="#ffcb05"
                        text-color="#000"
                    >
                        Under Process
                    </v-chip>
                </div>
                <div class="d-flex justify-content-between">
                    <div>
                        <strong class="font-size-md capitalize" v-if="item.portfolioType !== 'manual'"> {{item.planType}} - {{item.riskProfile}}</strong>
                        <strong class="font-size-md" v-else> Manual </strong>
                    </div>
                </div>
                <div class="portfolio-infoTable">
                    <div v-if="item.returnedInterest">
                        <p class="font-size-xs mb-0">Earnings</p>
                        <strong class="text-primary">&#x20B9;{{item.returnedInterest/100 | localeAmount}}</strong>
                    </div>
                    <div v-else>
                        <p class="font-size-xs mb-0">Expected Earnings</p>
                        <strong class="text-primary">&#x20B9;{{item.expectedEarning/100 | localeAmount}}</strong>
                    </div>
                    <div>
                        <p class="font-size-xs mb-0">A.P.R.</p>
                        <strong class="text-primary">{{calculateProfitPercentage(item)}}%</strong>
                    </div>
                    <div>
                        <p class="font-size-xs mb-0">Invested</p>
                        <strong class="text-primary">&#x20B9;{{calculateInvestmentAmount(item) | localeAmount}}</strong>
                    </div>
                </div>
            </div>
        </div>
        <div class="investment-card__cta">
            <router-link to="/loans/invested">View Loans</router-link>
            <router-link to="/transactions">View Transactions</router-link>
        </div>
    </div>
</template>

<script>
import AddFunds from '@/components/common/addFunds/addFunds.vue'
import LenderService from '@/services/lenderService'
const { setLocalStorage } = require('@/util/util.js')

export default {
    name: 'DashboardSidePanel-1',
    components: {
        AddFunds
    },
    props: {
        dashboardData: Object
    },
    data () {
        return {
            totalAccountValue: 500000,
            investedAmount: 121212,
            availableBalance: 0,
            portfolios: [],
            expectedEarning: 6580,
            profitPercentage: 18
        }
    },
    mounted () {
        this.getDashboardData()
    },
    methods: {
        async getDashboardData () {
            this.$store.commit('isLoading')
            const response = await Promise.all(
                [
                    LenderService.getVirtualAccountInfo(),
                    LenderService.getLenderPortfoliosInfo()
                ]
            )
            const accountInfo = response[0]
            const portfolioSummary = response[1]

            if (accountInfo.status === 200) {
                this.accountInfo = accountInfo.data
                this.$store.commit('dashboard/setField', { field: 'accountInfo', value: this.accountInfo })
            }

            if (portfolioSummary.status === 200) {
                this.portfolioSummary = portfolioSummary.data
                this.$store.commit('dashboard/setField', { field: 'portfolioSummary', value: this.portfolioSummary })
                this.portfolios = this.portfolioSummary.portfolios
            }
            if (portfolioSummary.status === 401 || accountInfo.status === 401) {
                this.$store.commit('setSessionOver')
            }
            this.isRequestSuccess = true
            this.$store.commit('isNotLoading')
        },
        isCreatedStatePortfolio (status) {
            if (!status) {
                return 'pointer'
            }
        },
        openPortfolio (item) {
            if (item.status) {
            } else {
                this.routeToFundsPage(item)
            }
        },
        routeToFundsPage (item) {
            if (this.$route.path !== '/invest') {
                setLocalStorage('cartItem', JSON.stringify(item))
                this.$router.push({ path: 'invest', query: { planSelected: 'true' } })
            }
        },
        calculateInvestmentAmount (item) {
            if (item.portfolioType === 'manual') {
                return (item.disbursedAmount + item.lockedAmount) / 100
            }
            return item.investmentAmount / 100
        },
        calculateProfitPercentage (item) {
            let percentage = 12
            if (item.planType === 'growth' && item.riskProfile === 'aggressive') {
                percentage = 18
            } else if (item.planType === 'growth' && item.riskProfile === 'conservative') {
                percentage = 14
            } else if (item.planType === 'income' && item.riskProfile === 'aggressive') {
                percentage = 16
            } else if (item.planType === 'income' && item.riskProfile === 'conservative') {
                percentage = 12
            } else {
                if (!(item.lockedAmount + item.disbursedAmount)) {
                    percentage = 0
                } else {
                    percentage = Math.round(((item.expectedEarning) / (item.lockedAmount + item.disbursedAmount)) * 100)
                }
            }
            return percentage
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~@/components/dashboard/dashboard.scss";
.portfolio-infoTable {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.investment-card {
    position: relative;
    &__cta {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;

        a {
            text-decoration: none;
            font-size: $font-size-xxs;
            font-weight: 500;
        }
    }
    .white-box {
        border: 1px solid $form-border-color;
        margin-bottom: 24px;
    }

    .capitalize {
        text-transform: capitalize;
    }
}

.underProcessIcon {
   position: absolute;
   right: 4px;
   top: 4px;
   z-index: 1;
}
</style>
